import { Controller, useFormContext, useWatch } from 'react-hook-form';

import { pluralize } from '@libs/i18n';
import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { Input } from '@ui/components/Input';

import { TournamentEditFormValues } from '@features/tournament/ui/components/TournamentSettings/typings';

const PLAYER_PLURAL = {
  many: 'участников',
  few: 'участника',
  one: 'участник',
  zero: 'участников',
};

const TEAM_PLURAL = {
  many: 'команд',
  few: 'команды',
  one: 'команда',
  zero: 'команд',
};

const MAX = 20;

export function RoundRobinMaxPartiesInput() {
  const { control } = useFormContext<TournamentEditFormValues>();
  const mode = useWatch({ name: 'mode', control });
  const isTeam = mode === 'Team' || mode === 'PrivateTeam' || mode === 'TwoOnTwo';
  return (
    <FormRow>
      <FormLabel>Макс. {isTeam ? 'команд' : 'участников'}</FormLabel>
      <FormInput>
        <Controller
          name="roundRobinSettings.maxPartiesCount"
          control={control}
          render={({ field: { value, onChange, disabled } }) => {
            const v = value ?? MAX;
            return (
              <Input
                invisible
                type="number"
                rightLabel={pluralize(isTeam ? TEAM_PLURAL : PLAYER_PLURAL, v)}
                value={v.toString()}
                onChange={onChange}
                min="3"
                max={v.toString()}
                disabled={disabled}
              />
            );
          }}
        />
      </FormInput>
    </FormRow>
  );
}
